import { Duplicate } from "./Duplicate";

export const Session = {
  Duplicate,
};
